<template>
    <div v-if="room">
        <div v-if="loaded">
            <div class="w3-row">
                <div class="w3-col w3-quarter">
                    <content-header v-bind:title="title"></content-header>
                </div>

                <div class="w3-col w3-quarter w3-right flow-content-actions-header flow-margin-bottom" v-if="!isNormal">
                    <div class="flow-padding-top w3-large w3-right flow-form-action active w3-margin-right">
                        <router-link :to="{name: 'consultation'}" class="flow-btn w3-btn w3-border w3-ripple w3-round-medium cursor-pointer w3-ripple flow-blue-color">
                            <i class="fa fa-calendar-alt flow-green-active-color"></i>
                            <b class="flow-margin-left">
                                {{ $t('goToConsultationsOverview') }}
                            </b>
                            <i class="fa fa-chevron-right"></i>
                        </router-link>
                    </div>
                </div>
            </div>

            <ConsultationInMinimalRoom v-if="hasMinimalStructure && physician !== undefined"
                                       :room="room"
                                       :propsPhysician="physician">
            </ConsultationInMinimalRoom>

            <consultation-in-room v-if="room.shared === false && physician !== undefined && !hasMinimalStructure"
                                  :roomId="room.id"
                                  :propsPhysician="physician">
            </consultation-in-room>

            <consultation-in-shared-room v-if="room.shared === true"
                                         :roomId="room.id">
            </consultation-in-shared-room>

            <div v-if="physician === undefined && room.shared === false" class="w3-container w3-center flow-blue-color">
                <h3 v-if="isNormal">{{$t('youAreNotLinked')}}</h3>
                <h3 v-else>{{$t('noPhysicianLinked')}}</h3>
                <h6 class="flow-blue-color">
                    <router-link :to="{name: 'rooms'}" class="flow-btn w3-btn w3-round-medium flow-blue-color">
                        <i class="fa fa-door-open flow-green-active-color flow-margin-right"></i>
                        <span v-if="isNormal">{{$t('linkYourself')}}</span>
                        <span v-else>{{$t('linkPhysician')}}</span>
                        <i class="fa fa-chevron-right flow-margin-left"></i>
                    </router-link>
                </h6>
            </div>
        </div>

        <div v-else>
            <spin-while-loading :dspin="true"></spin-while-loading>
        </div>

    </div>
</template>

<script>
    import Vue from 'vue';
    import ConsultationInRoom from "../components/consultation/ConsultationInRoom";
    import ConsultationInSharedRoom from "../components/consultation/ConsultationInSharedRoom";
    import ConsultationInMinimalRoom from "../components/consultation/ConsultationInMinimalRoom";
    import ContentHeader from "../components/common/ContentHeader";
    import SpinWhileLoading from "../components/common/Loading";

    const frc = Vue.prototype.$frc;

    export default {
        name: "Room",
        components: {SpinWhileLoading, ConsultationInSharedRoom, ConsultationInRoom, ContentHeader, ConsultationInMinimalRoom},
        data() {
            return {
                room: undefined,
                physician: undefined,
                loaded: false
            }
        },
        computed: {
            isNormal() {
                return Vue.isNormal(Vue.prototype.$currentUser.user.role);
            },
            title() {
                var title = "";

                if (!this.physician) {
                    title = this.room.name + " (" + this.room.group.displayName + ")";
                } else {
                    title = this.physician.name;
                }

                return title;
            },
            hasMinimalStructure() {
                var uiSettings = this.room.group.uiSettings.entry;
                var setting = Vue.getValueForKey(uiSettings, 'minimalRoomStructure');
                return setting;
            }
        },
        mounted() {
            this.getConsultationRoom();
        },
        methods: {
            getConsultationRoom() {
                const app = this;
                app.loaded = false;

                frc.getConsultationRoomInWard(Vue.prototype.$currentWard.id, this.$route.params.roomId).then(function(res) {
                    app.room = res.data;
                    if (!app.room.shared) {
                        frc.getPhysicianInRoom(Vue.prototype.$currentWard.id, app.room.id).then(function(res) {
                            app.physician = res.data;
                            app.loaded = true;
                        }).catch(function() {
                            app.loaded = true;
                        });
                    } else {
                        app.loaded = true;
                    }
                }).catch(function() {
                    app.loaded = true;
                });
            }
        }

    }
</script>

<style scoped>

</style>